import { Project } from './project';
import { Asset } from './asset';


export interface Section {
  id: number;
  projectId?: number;
  project?: Project;
  assets?: Asset[];
  name?: string;
  order?: number;
  state?: string;
}
